import React from "react";
import { Button } from "@mui/material";
import { Icon } from "@iconify/react";
import CryptoJS from "crypto-js";
import { studentUrl } from "../../../../utils/constants/links";

const WhatsappShare = ({ rowData }) => {
  const handleClick = () => {
    const password = "teaminterval"; // Must match PHP exactly
    const textToEncrypt = rowData.admn_no;

    function base64_encode(str) {
      return btoa(str);  // 'btoa' is a built-in JavaScript function for base64 encoding
    }

    function encryptLikePHP(plainText, password) {
      const key = CryptoJS.enc.Utf8.parse(password.padEnd(16, '\0'));
    
      const encrypted = CryptoJS.AES.encrypt(
        plainText.toString(),
        key,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
      );
    
       encrypted.ciphertext.toString(CryptoJS.enc.Base64);
      return base64_encode(encrypted.ciphertext.toString(CryptoJS.enc.Base64));
    }
     
    const encryptedBase64 = encryptLikePHP(textToEncrypt,password);

    const phone = `${rowData.student_country_code}${rowData.student_mob_no}`;
    if(rowData?.course_id==9){
      const url = `https://api.whatsapp.com/send?phone=${phone}&text= Please Complete Your Student's profile \n ${studentUrl}form/ecpc/${encryptedBase64}`;
      window.open(url, "_blank");
    }else{
      const url = `https://api.whatsapp.com/send?phone=${phone}&text= Please Complete Your Student's profile \n ${studentUrl}form/index/${encryptedBase64}`;
      window.open(url, "_blank");
    }
   
  };

  return (
    <Button variant="outlined" size="small" onClick={handleClick}>
      <Icon icon="logos:whatsapp-icon" width="25" height="25" />
    </Button>
  );
};

export default WhatsappShare;
